import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import
    {
        provideAppEnvironmentInfo,
        provideLocalizationConfig,
    } from '@contexts/jovdk-web';
import { provideThreeEnvironmentConfig } from '@contexts/jovdk-web-threejs';
import { DEFAULT_LOCALIZATION_CONFIG } from '@contexts/jovdk-web';
import { AppEnvironmentHandler, environment } from '../environments/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideLocalizationConfig(DEFAULT_LOCALIZATION_CONFIG),
        provideAppEnvironmentInfo({
            // appVersion: environment.APP_VERSION,
            appVersion: environment.WEB_SITE_01_FE_01_VERSION,
            // environmentName: environment.ENVIRONMENT_NAME,
            environmentName: environment.ENVIRONMENT_MAP_INTERNAL_ID,
            // cdnUrl: environment.CDN_URL,
            cdnUrl: environment.WEB_SITE_01_CDN_01_FULL_URL,
            // apiUrl: environment.API_URL,
            apiUrl: environment.WEB_SITE_01_API_SERVER_01_FULL_URL,
            isProduction: AppEnvironmentHandler.IsProd(),
            isLocal: AppEnvironmentHandler.IsLocal(),
        }),
        provideThreeEnvironmentConfig({
            // cdnUrl: environment.CDN_URL,
            cdnUrl: environment.WEB_SITE_01_CDN_01_FULL_URL,
            isLocal: AppEnvironmentHandler.IsLocal(),
        }),
        provideHttpClient(),
        provideRouter(routes),
        provideClientHydration(),
        provideAnimationsAsync(),
    ],
};

